// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterLink__link___1Y4B6"};